// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"a347352c","317":"8863daa1"}[chunkId] + ".chunk.js";
};